<template>
    <div class="search-wrapper" id="search-page">
        <!--<keep-alive :exclude="['knowledgeList','faqList','attachmentList']">-->
        <keep-alive>
            <router-view/>
        </keep-alive>
        <bottom-bar></bottom-bar>
    </div>
</template>

<script>
    import bottomBar from '@/views/search/bottomBar.vue';
    export default {
        name:'search',
        components:{bottomBar},
        created(){
            this.$store.commit('setBottomBar','')
        },
        data(){
            return{
                // 控制提问栏区域显示隐藏的3个变量
                setWanted: false,
                showWanted: false,
                boxScrolling: false,
                startY: 0,
            }
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .search-wrapper {
        font-size: j(28);
        color: #696D7F;
        height: 100%;
        overflow: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/views/search.vue